import React, { useState, useEffect } from 'react';
import './FileViewerPage.css';

const FileViewerPage = () => {
    const [files, setFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState('');

    useEffect(() => {
        const fileNames = ['SCHOOL_UP_AFFILIATION_OASIS.jpeg', 'WATER_TESTING_REPORT.jpeg', 'FIRE_CERTIFICATE.jpeg', 'UNDARTAKING.jpeg', 'MANDATORY_PUBLIC_DISCLOSURE.jpeg', 'MANDATORY_PUBLIC_DISCLOSURE_2026.pdf', 'MEDICAL_CERTIFICATE.jpeg'];
        const filePaths = fileNames.map(name => `/public_documents/${name}`);
        setFiles(filePaths);
    }, []);

    const handleFileClick = (fileName) => {
        setSelectedFile(fileName);
    };

    const lower = selectedFile.toLowerCase();
    const isImage = lower.endsWith('.png') || lower.endsWith('.jpg') || lower.endsWith('.jpeg');
    const isPdf = lower.endsWith('.pdf');

    return (
        <div className="file-viewer-page">
            <div className="file-list">
                <table>
                    <tbody>
                        {files.map(file => {
                            const fileNameWithoutExtension = file.split('/').pop().split('.')[0];
                            const formattedFileName = fileNameWithoutExtension.replace(/_/g, ' ');
                            return (
                                <tr key={file} onClick={() => handleFileClick(file)}>
                                    <td>{formattedFileName}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <div className="file-view-pane">
                <h3>{selectedFile.split('/').pop().split('.')[0].replace(/_/g, ' ')}</h3>
                {!selectedFile ? (
                    <p>Select a document from the list to view it.</p>
                ) : isImage ? (
                    <img className="view-image" src={selectedFile} alt="Selected" />
                ) : isPdf ? (
                    <div>
                        <a href={selectedFile} target="_blank" rel="noopener noreferrer"
                           style={{ display: 'inline-block', marginBottom: '12px', padding: '8px 16px', background: '#1a5fb4', color: '#fff', borderRadius: '6px', textDecoration: 'none' }}>
                            Open / Download PDF
                        </a>
                        <iframe src={selectedFile} title="Document" width="100%" height="800px" style={{ border: '1px solid #ccc' }} />
                    </div>
                ) : (
                    <p>File content cannot be displayed</p>
                )}
            </div>
        </div>
    );
};

export default FileViewerPage;
